import { render } from "./Frequencies.vue?vue&type=template&id=3597a592"
import script from "./Frequencies.vue?vue&type=script&lang=js"
export * from "./Frequencies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__